var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tables),function(content,index){return _c('page-table',{key:index,attrs:{"tableContent":content,"page":_vm.page,"formNumber":_vm.formNumber,"tableNumber":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }